import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material"
import { setCheckoutOption } from "src/features/checkout/checkoutSlice"
import { DELIVERY_OPTIONS } from "src/app/constants"

export default function PickupScheduleCard() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const options = useSelector((state) => state.checkout.options)

  function goToPickup() {
    dispatch(
      setCheckoutOption({
        deliveryOption: DELIVERY_OPTIONS.LOCAL_PICKUP,
        zip: null,
        specialEvent: null,
      }),
    )
    navigate("../schedule", {
      state: {
        previousOptions: options,
      },
    })
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="body1">
          If you prefer a warehouse pickup during these hours:
        </Typography>
        <Typography component="div" variant="body1" p={0} m={0}>
          <Stack>
            <span>
              • <strong>Weekdays</strong> 10:00 AM - 4:00 PM
            </span>
            <span>
              • <strong>Weekends</strong> 3:00 PM - 4:00 PM
            </span>
          </Stack>
          <Box mt={1}>
            Please click here:{" "}
            <Button color="primary" variant="contained" onClick={goToPickup}>
              Warehouse Pickup
            </Button>
          </Box>
        </Typography>
      </CardContent>
    </Card>
  )
}
